module.exports = __webpack_public_path__ + "static/img/RAZB16_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAZB16_1.png
// module id = Z0fQ
// module chunks = 0